kv.controller('InvoiceCurrencyRate', function ($uibModalInstance, currency_rate_exchange, $injector, $scope) {
	var vm = new modalCtrl($uibModalInstance, $injector, 'currency_rate', 'currencey_rate_id', $scope);
	vm.currency_rate = currency_rate_exchange;

	vm.save = function () {
		vm.modal.close({currency_rate: vm.currency_rate});
	};
	return vm;
});
